import React, { useEffect, useMemo, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import { useT } from '../../i18n/LocaleContext';

const PATH_TO_PAGE_KEY = [
  { test: /^\/dashboard/, key: 'dashboard' },
  { test: /^\/members/, key: 'members' },
  { test: /^\/events/, key: 'events' },
  { test: /^\/payments/, key: 'payments' },
  { test: /^\/reservations/, key: 'reservations' },
  { test: /^\/transport/, key: 'transport' },
  { test: /^\/finance/, key: 'finance' },
  { test: /^\/payouts/, key: 'payouts' },
  { test: /^\/documents/, key: 'documents' },
  { test: /^\/settings/, key: 'settings' },
  { test: /^\/reports/, key: 'reports' },
  { test: /^\/users/, key: 'users' },
  { test: /^\/roles/, key: 'roles' },
  { test: /^\/audit/, key: 'audit' },
  { test: /^\/profile/, key: 'profile' },
  { test: /^\/forbidden/, key: 'forbidden' },
];

export default function AppLayout() {
  const t = useT();
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 960);
  const [sidebarOpen, setSidebarOpen] = useState(() => window.innerWidth > 960);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 960px)');
    const handleChange = (event) => {
      setIsMobile(event.matches);
      setSidebarOpen(!event.matches);
    };
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  const pageMeta = useMemo(() => {
    const match = PATH_TO_PAGE_KEY.find((m) => m.test.test(location.pathname));
    const key = match ? match.key : 'dashboard';
    return {
      title: t(`pages.${key}.title`),
      subtitle: t(`pages.${key}.subtitle`),
    };
  }, [location.pathname, t]);

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden', position: 'relative' }}>
      {isMobile && sidebarOpen && (
        <div
          onClick={() => setSidebarOpen(false)}
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(13,31,60,0.42)',
            zIndex: 90,
          }}
        />
      )}
      <Sidebar
        isMobile={isMobile}
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <Topbar
          title={pageMeta.title}
          subtitle={pageMeta.subtitle}
          isMobile={isMobile}
          onOpenMenu={() => setSidebarOpen(true)}
        />
        <div
          style={{
            flex: 1,
            overflowY: 'auto',
            padding: isMobile ? '16px' : '28px',
            background: 'var(--ivory)',
          }}
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
}
